import _ from 'lodash'

let component = {
    rootNode: null,
    api: null,
    vueElementsByNodeUUID: new Map()
}
component.setClientAPI = (a) => {
    component.rootNode = a.getSchema()?.elements
    component.api = a
    component.vueElementsByNodeUUID = new Map()
}

component.getRootElement = () => component.rootNode

component.applyAll = (nodeHandlerFN, node) => {
    if (!nodeHandlerFN) return;
    node = node || component.rootNode;
    nodeHandlerFN(node);

    node.children = node.children || [];
    window._.each(node.children, child => {
        component.applyAll(nodeHandlerFN, child);
    });
    return node;
}

component.applyAllVueChildren = (nodeHandlerFN, node) => {
    if (!nodeHandlerFN) return;
    nodeHandlerFN(node);
    window._.each(node.$children, child => {
        component.applyAllVueChildren(nodeHandlerFN, child);
    });
    return node;
}

component.flatten = (rootNodes) => {
    let elementComponents = [];
    rootNodes = Array.isArray(rootNodes) ? rootNodes : [rootNodes];
    rootNodes.forEach(rootNode => {
        component.applyAll(n => elementComponents.push(n), rootNode, rootNode);
    });

    return elementComponents;
};

component.renewLastUpdate = () => {
    let c1 = 0;
    let d = new Date().getTime()
    component.applyAll(n => {
        n.lastUpdate = `${d}-${(c1++)}`;
    });
}
component.forceUpdate = () => {
    // window.console.log('invocando forceupdate')
    // window.console.trace()
    component.api.renewLastUpdate()
    // POR VER SI ESTO ES NECESARIO O NO (2024-01-31)
    // component.api.eventPublish(component.api.events.EVENT_ON_UPDATE, {})
}

component.getElementForName = (name) => {
    return _.find(component.flatten(), { name : name } )
}

component.registerVueElement = (vueInstance) => {
    const nodeUUID = vueInstance?.nodeUUID || vueInstance?.node?.nodeUUID
    if (!nodeUUID) return

    component.vueElementsByNodeUUID.set(nodeUUID, vueInstance)
}

component.unregisterVueElement = (vueInstance) => {
    const nodeUUID = vueInstance?.nodeUUID || vueInstance?.node?.nodeUUID
    if (!nodeUUID) return

    const current = component.vueElementsByNodeUUID.get(nodeUUID)
    if (current === vueInstance) {
        component.vueElementsByNodeUUID.delete(nodeUUID)
    }
}

component.getVueElementForNode = (n) => {
    if (!(n || {}).nodeUUID) return null
    const registered = component.vueElementsByNodeUUID.get(n.nodeUUID)
    if (registered) return registered
    // let v = (document.querySelectorAll(`[__id="${n.nodeUUID}"]`)[0] || {}).__vue__
    // if (v) return v

    let elements = Array.from(document.getElementsByTagName('*'));
    elements = elements.filter( e => (e.__vue__ || {}).nodeUUID )
    elements = elements.filter( e => e.__vue__.nodeUUID === n.nodeUUID)
    const vueInstance = elements.length === 1 ? elements[0].__vue__ : null
    if (vueInstance) component.registerVueElement(vueInstance)
    return vueInstance
}
/*
component.getVueElementForNode = (n) => {
    if (!(n || {}).nodeUUID) return null
    // return (document.getElementById(n.nodeUUID) || {}).__vue__
    let elements = Array.from(document.getElementsByTagName('*'));
    elements = elements.filter( e => (e.__vue__ || {}).nodeUUID )
    elements = elements.filter( e => e.__vue__.nodeUUID === n.nodeUUID)
    return elements.length === 1 ? elements[0].__vue__ : null
}
*/

component.getElementForType = (type) => {
    return _.filter(component.flatten(), { componentType : type } )
}

export default component
